import React, { Component } from "react";

import ApiLocalidade from "./api-localidade";

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    option: {
        fontSize: 15,
        '& > span': {
            marginRight: 10,
            fontSize: 18,
        },
    },
});

class ListaEstados extends Component { 
    state = {
        data: [],
        value : {}
    }  

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        const { valueId } = this.props;

        if (valueId !== prevProps.valueId && valueId !== "") {
            this.setValue(valueId);
        }
    }

    setValue = async (id) => {
        let valor = {} 
        const estados = this.state.data;        

        for (let a in estados) {
            if (estados[a].id_estado === id) {
                valor = estados[a];
                break;
            }
        }

        this.setState({
            value: valor,
        })
    }

    loadData = async () => {
        const response = await ApiLocalidade.GetEstados();

        this.setState({
            data: response.data,
        });

        await this.setValue("SC");
    }

    render() {
        const { classes, ...other } = this.props;
        const { data, value } = this.state;   

        return (
            <Autocomplete
                {...other}
                id="estados-select-demo"
                options={data}
                autoHighlight
                fullWidth
                getOptionLabel={(option) => option.nome}
                renderOption={(option) => (
                        <React.Fragment>
                            {option.nome} ({option.id_estado})
                        </React.Fragment>
                    )}
                value={value}
                renderInput={(params) => (
                <TextField
                    {...params}
                    label="Estado"
                    variant="outlined"
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password',
                    }}
                />
                )}
            />
        )
    }
}

export default withStyles(styles)(ListaEstados);